// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';
import './swiper.scss';

// var swiper = new Swiper('.swiperNav', {
//   loop: true,
//   spaceBetween: 0,
//   slidesPerView: 7,
//   freeMode: true,
//   watchSlidesProgress: true,
// });
// var swiper2 = new Swiper('.swiperMain', {
//   loop: true,
//   spaceBetween: 0,
//   effect: 'fade',

//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   thumbs: {
//     swiper: swiper,
//   },
// });

var swiper = new Swiper('.indexSlide', {
  loop: true,
  spaceBetween: 0,
  // slidesPerView: 7,
  freeMode: true,
  watchSlidesProgress: true,

  autoplay: {
    delay: 3500, // 3秒間隔でスライド
    disableOnInteraction: false, // ユーザーが操作しても自動スライドを継続
    // pauseOnMouseEnter: true, // マウスホバー時に一時停止
  },
  // フェードエフェクトの設定
  fadeEffect: {
    crossFade: true, // クロスフェードを有効化
  },
  speed: 1200,

  effect: 'fade', //追加 フェード機能をONにする
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
